import PerformanceComparisonBase from '../../PerformanceComparisonBase.js';
import * as Enums from '../../../../enums/index.js';

const mphToMs = Enums.ImperialToSiConversion.MPH_MPS.ratio;
const ftToM = Enums.ImperialToSiConversion.FT_M.ratio;

const batterMlb = new PerformanceComparisonBase(null, Object.assign({}, Enums.BattingStats, Enums.HitData), 'MLB - 2019');

// max values are based on previous research for data sanitization
// for exit speed / launch angles https://docs.google.com/document/d/1xbRySES57yygj-AaSbWViNWlcQnJqnzt6pCHOoVPv9E/edit#heading=h.iu2v4mqihw7s
// and MLB data 
// https://baseballsavant.mlb.com/leaderboard/statcast?type=batter&year=2019&position=&team=&min=1

// For all pitch types...
// @see https://docs.google.com/spreadsheets/d/1nZ7KB2nXy9MXpjZkW_oa7zABeBqVmFHlN4eir_Uajqg/edit#gid=44543296&range=H2
batterMlb.set(null, Enums.HitData.ExitSpeed.key, 86.86 * mphToMs, 134 * mphToMs);

// @see https://docs.google.com/spreadsheets/d/1nZ7KB2nXy9MXpjZkW_oa7zABeBqVmFHlN4eir_Uajqg/edit#gid=44543296&range=E2
batterMlb.set(null, Enums.HitData.LaunchV.key, 7.99, 90);

// no data to compare here...
batterMlb.set(null, Enums.HitData.LaunchH.key, NaN, 180);

// @see https://docs.google.com/spreadsheets/d/1nZ7KB2nXy9MXpjZkW_oa7zABeBqVmFHlN4eir_Uajqg/edit#gid=44543296&range=L2
batterMlb.set(null, Enums.HitData.CarryDistance.key, 147.99 * ftToM, 508 * ftToM);

// https://docs.google.com/spreadsheets/d/1ptrjam4_Q0KntSr2E04yu_K_pRFs1Okt7rS6_XCoXvg/edit#gid=1685376598
batterMlb.set(null, Enums.BattingStats.HardHitRate.key, 37.17, 100); // hard_hit_percent, weights: pitches

export default batterMlb;